<template>
  <v-data-table
    :headers="headers"
    :items="locations"
    sort-by="locationName"
    :search="search"
    class="elevation-1"
    v-model="selected"
    item-key="locationName"
    multi-sort
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Search"
          v-model="search"
          hide-details
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-bottom-sheet v-model="sheet">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              @click="clearSheet"
              v-if="checkRole(['lf','dealer'])"
            >
              New Location
            </v-btn>
          </template>

          <v-card>
            <v-tabs
              centered
              fixed-tabs
              background-color="cyan"
              dark
              icons-and-text
              v-model="tab"
            >
              <v-spacer></v-spacer>

              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab href="#tab-1">
                Main
                <v-icon>mdi-home</v-icon>
              </v-tab>

              <v-spacer></v-spacer>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editMode = !editMode"
                v-if="!editMode && checkRole(['lf', 'dealer'])"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              
              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editMode = !editMode"
                v-if="editMode"
              >
                <v-icon>mdi-pencil-off</v-icon>
              </v-btn>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="close()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-tab-item :key="1" :value="'tab-1'">
                <v-card flat>
                  <v-form ref="form">
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.locationName"
                            label="Location Nickname"
                            name="locationNickname"
                            :rules="rules.required"
                            required
                            hint="Required"
                            persistent-hint
                            append-icon="mdi-content-copy"
                            @click:append="copyLocationDescription()"
                            color="cyan"
                            :readonly="!editMode"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-alert
                            dense
                            text
                            :color="alert.color"
                            :icon="alert.icon"
                          >
                            Note: Location description, address, city and state cannot all be left blank. At least one field must be completed.
                          </v-alert>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-text-field
                            v-model="editedItem.locationDescription"
                            label="Location Description"
                            append-icon="mdi-content-copy"
                            @click:append="copyLocationName()"
                            color="cyan"
                            :hint="'Shown on certificate. ' + certFieldsCount + ' of 1 required fields filled'"
                            persistent-hint
                            @keyup="updateCertFields()"
                            :readonly="!editMode"
                          >
                          </v-text-field>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-text-field
                            v-model="editedItem.locationAddress"
                            label="Address"
                            color="cyan"
                            :hint="'Shown on certificate. ' + certFieldsCount + ' of 1 required fields filled'"
                            persistent-hint
                            @keyup="updateCertFields()"
                            :readonly="!editMode"
                          ></v-text-field>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-text-field
                            v-model="editedItem.locationAddress2"
                            label="Address 2"
                            color="cyan"
                            :hint="'Shown on certificate. ' + certFieldsCount + ' of 1 required fields filled'"
                            persistent-hint
                            @keyup="updateCertFields()"
                            :readonly="!editMode"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="3"
                        >
                          <v-text-field
                            v-model="editedItem.locationCity"
                            label="City"
                            color="cyan"
                            :hint="'Shown on certificate. ' + certFieldsCount + ' of 1 required fields filled'"
                            persistent-hint
                            @keyup="updateCertFields()"
                            :readonly="!editMode"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                        >
                          <v-autocomplete
                            v-model="editedItem.locationState"
                            :items="states"
                            label="State"
                            item-text="state"
                            item-value="abbr"
                            color="cyan"
                            item-color="cyan"
                            clearable
                            :hint="'Shown on certificate. ' + certFieldsCount + ' of 1 required fields filled'"
                            persistent-hint
                            @change="updateCertFields()"
                            :readonly="!editMode"
                            ></v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                        >
                          <v-text-field
                            v-model="editedItem.locationZip"
                            label="Postal"
                            color="cyan"
                            :readonly="!editMode"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                        >
                          <v-autocomplete
                            v-model="editedItem.locationCountry"
                            :items="countries"
                            label="Country"
                            item-text="country"
                            item-value="abbr"
                            color="cyan"
                            item-color="cyan"
                            clearable
                            :readonly="!editMode"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-text-field
                            v-model="editedItem.locationContact"
                            label="Contact Name"
                            color="cyan"
                            :readonly="!editMode"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-text-field
                            v-model="editedItem.locationPhone"
                            label="Phone"
                            color="cyan"
                            :readonly="!editMode"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="4"
                        >
                          <v-text-field
                            v-model="editedItem.locationEmail"
                            label="E-mail"
                            color="cyan"
                            :readonly="!editMode"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>

                    <v-container v-if="checkRole(['lf', 'dealer'])">
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="close">Cancel</v-btn>
                        <v-btn color="cyan" dark @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-container>
                  </v-form>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-bottom-sheet>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="closeDelete">Cancel</v-btn>
              <v-btn color="error" dark @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-divider></v-divider>
    </template>

    <template v-slot:item.locationName="props">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span
            class="subtitle-1"
            style="border-bottom: 1px dashed #111; cursor: pointer;"
            @click="editItem(props.item)"
            v-bind="attrs"
            v-on="on"
          >
            {{ props.item.locationName }}
          </span>
        </template>
        <span>View Location</span>
      </v-tooltip>

      <v-tooltip
        top
        v-if="$route.path == '/dealers/locations' || ($route.path == '/locations' && checkRole('ROLE_DEALERADMIN'))"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-2"
            icon
            v-bind="attrs"
            v-on="on"
            @click="$router.push($route.path + '/lols?locationid=' + props.item.locationID);"
          >
            <v-icon>
              mdi-location-enter
            </v-icon>
          </v-btn>
        </template>
        <span>Go to LOLs</span>
      </v-tooltip>

      <v-tooltip
        top
        v-else
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-2"
            icon
            v-bind="attrs"
            v-on="on"
            @click="$router.push($route.path + '/sources?locationid=' + props.item.locationID);"
          >
            <v-icon>
              mdi-location-enter
            </v-icon>
          </v-btn>
        </template>
        <span>Go to Air Sources</span>
      </v-tooltip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <span>Actions</span>
          </v-tooltip>
        </template>
        <v-list>
          <template v-for="(action, key) in actionsMenu">
            <v-list-item
              :key="key"
              :to="$route.path + '/' + action.path + '?locationid=' + item.locationID"
            >
              <v-list-item-action class="mr-4">
                <v-icon v-bind:style="{ color: action.color}" v-text="action.icon"></v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  v-text="$vuetify.lang.t('$vuetify.menu.' + action.item)"
                />
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item @click="editItem(item)">
            <v-list-item-action class="mr-4">
              <v-icon>mdi-magnify</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>View</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item @click="deleteItem(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="red">mdi-trash-can-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
      </v-menu>
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
  import LocationService from "../../../services/location.service"
  import CustomerService from "../../../services/customer.service"
  import States from "../../../api/state.js"
  import Countries from "../../../api/country.js"

  export default {
    data: () => ({
      search: '',
      message: '',
      selected: [],
      sheet: false,
      tab: null,
      dialog: false,
      dialogDelete: false,
      headers: [
        { text: "Location", align: "start", value: "locationName" },
        { text: "State", value: "locationState" },
        { text: "City", value: "locationCity" },
        { text: "Address", value: "locationAddress" },
        { text: "Description", value: "locationDescription" },
        { text: "Contact", value: "locationContact" },
        { text: "Actions", value: "actions", align: "center", sortable: false }
      ],
      locations: [],
      editedIndex: -1,
      editedItem: {
        locationName: '',
        locationDescription: '',
      },
      defaultItem: {
        locationName: '',
        locationDescription: ''
      },
      actionsMenu: [],
      states: States,
      countries: Countries,
      certFieldsCount: 0,
      alert: {
        color: 'primary',
        icon: 'mdi-alert-circle'
      },
      editMode: false,
      rules: {
        required: [
          value => value.length != 0 || 'Required'
        ]
      },
    }),

    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      
      dialogDelete (val) {
        val || this.closeDelete()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize() {
        this.checkAuth()
        this.retrieveLocations()
        this.computeActionsMenu()
      },

      checkAuth() {
        if (!this.$route.meta.authorize.includes(this.currentUser.roles.toString())) {
          this.$router.push('/dashboard')
        }
      },

      checkRole(role) {
        if (Array.isArray(role)) {
          var i
          for (i = 0; i < role.length; i++) {
            if (this.currentUser.roles.includes(role[i])) {
              return true
            }
            if (role[i] == 'lf') {
              if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
                return true
              }
            }
            if (role[i] == 'dealer') {
              if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
                return true
              }
            }
          }
          return false
        }

        if (role == 'lf') {
          if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
            return true
          }
        }

        if (role == 'dealer') {
          if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
            return true
          }
        }

        if (this.currentUser.roles.includes(role)) {
          return true
        } else {
          return false
        }
      },

      computeActionsMenu() {
        if (this.$route.path == '/dealers/locations') {
          this.actionsMenu = [
            {
              item: "lols",
              path: "lols",
              icon: "mdi-tablet-cellphone",
              color: ""
            },
            {
              item: "certificates",
              path: "certificates",
              icon: "mdi-certificate-outline",
              color: ""
            },
            {
              item: "schedule",
              path: "schedule",
              icon: "mdi-calendar-month-outline",
              color: ""
            }
          ]
        } else if (this.$route.path == '/dealers/clients/locations') {
          this.actionsMenu = [
            {
              item: "air sources",
              path: "sources",
              icon: "mdi-cloud-outline",
              color: ""
            },
            {
              item: "certificates",
              path: "certificates",
              icon: "mdi-certificate-outline",
              color: ""
            },
            {
              item: "schedule",
              path: "schedule",
              icon: "mdi-calendar-month-outline",
              color: ""
            }
          ]
        } else if (this.$route.path == '/clients/locations') {
          this.actionsMenu = [
            {
              item: "air sources",
              path: "sources",
              icon: "mdi-cloud-outline",
              color: ""
            },
            {
              item: "certificates",
              path: "certificates",
              icon: "mdi-certificate-outline",
              color: ""
            },
            {
              item: "schedule",
              path: "schedule",
              icon: "mdi-calendar-month-outline",
              color: ""
            }
          ]
        } else if (this.$route.path == '/locations' && this.$route) {
          if (this.checkRole("ROLE_DEALERADMIN")) {
            this.actionsMenu = [
              {
                item: "lols",
                path: "lols",
                icon: "mdi-tablet-cellphone",
                color: ""
              },
              {
                item: "certificates",
                path: "certificates",
                icon: "mdi-certificate-outline",
                color: ""
              },
              {
                item: "schedule",
                path: "schedule",
                icon: "mdi-calendar-month-outline",
                color: ""
              }
            ]
          } else if (this.checkRole("ROLE_CLIENT")) {
            this.actionsMenu = [
              {
                item: "air sources",
                path: "sources",
                icon: "mdi-cloud-outline",
                color: ""
              },
              {
                item: "certificates",
                path: "certificates",
                icon: "mdi-certificate-outline",
                color: ""
              },
              {
                item: "schedule",
                path: "schedule",
                icon: "mdi-calendar-month-outline",
                color: ""
              }
            ]
          }
        }
      },

      retrieveLocations() {
        if (this.checkRole('lf')) {
          if (this.$route.query.customerid) {
            LocationService.getCustomerLocations(this.$route.query.customerid)
              .then(response => {
                this.locations = response.data || [];
              })
              .catch(e => {
                console.log(e);
                window._LOL2P.$emit('SHOW_SNACKBAR', {
                  text: 'There was an error retrieving locations',
                  color: 'error'
                })
              });
          } else {
            LocationService.getAll()
              .then(response => {
                this.locations = response.data || [];
              })
              .catch(e => {
                console.log(e);
                window._LOL2P.$emit('SHOW_SNACKBAR', {
                  text: 'There was an error retrieving locations',
                  color: 'error'
                })
              });
          }
        } else if (this.$route.path == "/clients/locations" && this.checkRole("ROLE_DEALERADMIN")) {
          if (this.$route.query.customerid) {
            CustomerService.get(this.$route.query.customerid)
              .then(response => {
                if (response.data.dealerID == this.currentUser.customerID) {
                  LocationService.getCustomerLocations(this.$route.query.customerid)
                    .then(response => {
                      this.locations = response.data || [];
                    })
                    .catch(e => {
                      console.log(e);
                      window._LOL2P.$emit('SHOW_SNACKBAR', {
                        text: 'There was an error retrieving locations',
                        color: 'error'
                      })
                    });
                }
              })
              .catch(e => {
                console.log(e);
                window._LOL2P.$emit('SHOW_SNACKBAR', {
                  text: 'There was an error retrieving locations',
                  color: 'error'
                })
              });
          } else {
            LocationService.getDealerClientLocations(this.currentUser.customerID)
              .then(response => {
                this.locations = response.data || [];
              })
              .catch(e => {
                console.log(e);
                window._LOL2P.$emit('SHOW_SNACKBAR', {
                  text: 'There was an error retrieving locations',
                  color: 'error'
                })
              });
          }
        } else if (this.$route.path == "/locations") {
          if (this.checkRole("ROLE_DEALERADMIN") || this.checkRole("ROLE_CLIENT")) {
            LocationService.getCustomerLocations(this.currentUser.customerID)
              .then(response => {
                this.locations = response.data || [];
              })
              .catch(e => {
                console.log(e);
                window._LOL2P.$emit('SHOW_SNACKBAR', {
                  text: 'There was an error retrieving locations',
                  color: 'error'
                })
              });
          } else {
            this.$router.push('/dashboard')
          }
        }
      },

      async createLocation() {
        if (this.$route.query.customerid) {
          this.editedItem.customerID = this.$route.query.customerid
        } else {
          this.editedItem.customerID = this.$store.state.auth.user.customerID
        }

        let locationID = null

        await LocationService.create(this.editedItem)
          .then(response => {
            this.snackbar("Success! The location was created successfully","success")
            locationID = response.data.locationID
            this.locations.push(this.editedItem)

            return new Promise(resolve => {
              resolve('Done')
            })
          })
          .catch(e => {
            console.log(e);
            if (e.response && e.response.status === 400) {
              this.snackbar(e.response.data.message, 'error')
            } else {
              this.snackbar('Error! There was an error creating the location', 'error')
            }
          })
        return locationID
      },

      updateLocation() {
        LocationService.update(this.editedItem.locationID, this.editedItem)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The location was updated successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e);
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'There was an error updating the location',
              color: 'error'
            })
          });
      },

      deleteLocation() {
        LocationService.delete(this.editedItem.locationID)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The location was deleted successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e);
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'There was an error deleting the location',
              color: 'error'
            })
          });
      },

      routerPush(locationID) {
        LocationService.get(locationID)
          .then(res => {
            CustomerService.get(res.data.customerID)
              .then(res => {
                if (res.data.dealerID) {
                  this.$router.push('/companies/sources/?locationid=' + locationID)
                } else {
                  this.$router.push('/lols/lols/?locationid=' + locationID)
                }
              })
          })
      },

      clearSheet() {
        this.editedItem.locationName = ''
        this.editedItem.locationDescription = null
        this.editedItem.locationContact = null
        this.editedItem.locationPhone = null
        this.editedItem.locationEmail = null
        this.editedItem.locationAddress = null
        this.editedItem.locationAddress2 = null
        this.editedItem.locationCity = null
        this.editedItem.locationState = null
        this.editedItem.locationZip = null
        this.editedItem.locationCountry = null
        this.editedIndex = -1
        this.tab = 1
        this.updateCertFields()
        this.editMode = true
      },

      editItem (item) {
        this.editedIndex = this.locations.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.updateCertFields()
        this.sheet = true
        this.editMode = false
      },

      deleteItem (item) {
        this.editedIndex = this.locations.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.locations.splice(this.editedIndex, 1)
        this.deleteLocation();
        this.closeDelete()
      },

      close () {
        this.sheet = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        if (!this.$refs.form.validate() || (!this.editedItem.locationDescription && !this.editedItem.locationAddress && !this.editedItem.locationCity && !this.editedItem.locationState)) {
          this.alert = {
            color: 'error',
            icon: 'mdi-close-circle'
          }
          this.snackbar('Error! Missing location information', 'error', '3000')
          return
        }

        if (this.editedIndex > -1) {
          Object.assign(this.locations[this.editedIndex], this.editedItem);
          this.updateLocation();
        } else {
          this.editedItem.locationID = await this.createLocation()
        }
        this.close()
      },

      copyLocationDescription() {
        this.editedItem.locationName = this.editedItem.locationDescription
        this.updateCertFields()
      },

      copyLocationName() {
        this.editedItem.locationDescription = this.editedItem.locationName
        this.updateCertFields()
      },

      updateCertFields() {
        this.certFieldsCount = 0

        if (this.editedItem.locationDescription) {
          this.certFieldsCount++
        }
        if (this.editedItem.locationAddress) {
          this.certFieldsCount++
        }
        if (this.editedItem.locationAddress2) {
          this.certFieldsCount++
        }
        if (this.editedItem.locationCity) {
          this.certFieldsCount++
        }
        if (this.editedItem.locationState) {
          this.certFieldsCount++
        }

        if (this.certFieldsCount > 0 || this.editedItem.locationName == '') {
          this.alert = {
            color: 'primary',
            icon: 'mdi-alert-circle'
          }
        } else {
          this.alert = {
            color: 'error',
            icon: 'mdi-close-circle'
          }
        }
      },

      snackbar(message, color, timeout) {
        window._LOL2P.$emit('SHOW_SNACKBAR', {
          text: message,
          color: color,
          timeout: timeout
        })
      },
    },
  }
</script>